import { Component, ReactNode } from 'react';
import { connect } from 'react-redux';

// import DropList from 'components/atoms/DropList'
import TabsLayout from 'components/atoms/TabsLayout';
import { bindActionCreators, Dispatch } from 'redux';
import {
    transitCreateComment,
    transitGetComments,
    transitGetTags,
    transitUpdateComment,
    transitUpdateTags,
} from 'services/transits';
import { SetErrorHandlerAction, setErrorHandlerAction } from 'store/actions/errorsActions';
import { OpenModal, PortType, RootState, TagType, UserCommentType } from 'types';
import { MainControlsInterface } from 'types/functions';
import { ActionsType } from 'types/system';
import { checkDifferent, clone } from 'utils/formHandlers';

import CommentsTab from './tabs/CommentsTab';
import TagsTab from './tabs/TagsTab';
import { formatComments, formatTransitTags, linkTagType } from 'utils/migrations';

interface TransitTagsAndCommentsModelProps {
    //unused props
    openModelFunction: OpenModal;

    id?: string;
    data: any;
    actions: ActionsType | undefined;
    action?: (data: UserCommentType, index?: string) => void;
    tags: TagType[];
    //unused props
    language?: string;

    mainControls: MainControlsInterface;
    port: PortType;
    setErrorHandlerAction: SetErrorHandlerAction;
}

interface TransitTagsAndCommentsModelState {
    tabs: { [key: string]: ReactNode };
    errors: any;
    activeTab: string;

    //unused state
    edit: boolean;
    data: any;
    loading: boolean;
    comment: UserCommentType;
    comments: UserCommentType[];
    selectedTags: (number | string)[];
    sourceSelectedTags: (number | string)[];
}

class TransitTagsAndCommentsModel extends Component<
    TransitTagsAndCommentsModelProps,
    TransitTagsAndCommentsModelState
> {
    constructor(props: TransitTagsAndCommentsModelProps) {
        super(props);
        this.state = {
            tabs: {},
            data: {},
            activeTab: props.data.tab,
            errors: {},
            loading: false,
            edit: false,
            comments: [],
            comment: {
                text: '',
                type: 'private',
            },
            selectedTags: [],
            sourceSelectedTags: [],
        };
    }

    componentDidMount(): void {
        this.getComments();
        this.getTags();
        this.renderData();
    }

    getComments = () => {
        transitGetComments(this.props.port.id, this.props.data.id)
            .then((res) => {
                this.setState({
                    comments: formatComments(res, this.props.port.backEnd?.version || 1),
                });
            })
            .catch((errors) => {
                this.props.setErrorHandlerAction(errors);
            });
    };

    getTags = () => {
        transitGetTags(this.props.port.id, this.props.data.id)
            .then((res) => {
                this.setState({
                    selectedTags: formatTransitTags(res, this.props.port.backEnd?.version || 1).map((x) => {
                        return x.tag_id;
                    }),
                    sourceSelectedTags: formatTransitTags(res, this.props.port.backEnd?.version || 1).map((x) => {
                        return x.tag_id;
                    }),
                });
            })
            .catch((errors) => {
                this.props.setErrorHandlerAction(errors);
            });
    };

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.save();
    };

    handleFormCancel = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onCancel();
    };

    handleFormClear = () => {
        this.setState({
            selectedTags: this.state.sourceSelectedTags,
        });
    };

    setTag = (id: number, type: string) => {
        this.setState(
            (prevState) => ({
                selectedTags: prevState.selectedTags.includes(id)
                    ? prevState.selectedTags.filter((tagId) => tagId !== id)
                    : [...prevState.selectedTags, id],
            }),
            this.renderData
        );
    };

    setComment = (text: string, type: string) => {
        this.setState(
            {
                comment: { ...this.state.comment, text, type },
            },
            this.renderData
        );
    };

    editComment = (comment: any) => {
        this.setState({ comment: clone(comment) });
    };

    componentDidUpdate(prevProps: TransitTagsAndCommentsModelProps, prevState: TransitTagsAndCommentsModelState) {
        if (
            checkDifferent(prevState.comments, this.state.comments) ||
            checkDifferent(prevState.comment, this.state.comment) ||
            checkDifferent(prevState.data, this.state.data) ||
            checkDifferent(prevState.selectedTags, this.state.selectedTags) ||
            checkDifferent(prevState.errors, this.state.errors)
        ) {
            this.renderData();
        }
    }

    onTabChange = (tab: string, nextTab: string) => {
        this.setState({ activeTab: nextTab });
        return true;
    };

    save = () => {
        this.setState({ loading: true }, async () => {
            try {
                // Update tags

                const tags =
                    this.props.port.backEnd?.version === 2
                        ? (() => {
                              const source = new Set(this.state.sourceSelectedTags);
                              const selected = new Set(this.state.selectedTags);

                              const allTags = [...new Set([...source, ...selected])];

                              return allTags
                                  .map((key) => {
                                      const tag = this.props.tags.find((t) => t.key === key);

                                      if (!tag) {
                                          return null;
                                      }

                                      let action: 'add' | 'update' | 'delete';

                                      if (selected.has(key) && source.has(key)) {
                                          action = 'update';
                                      } else if (selected.has(key)) {
                                          action = 'add';
                                      } else {
                                          action = 'delete';
                                      }

                                      return {
                                          id: tag.key,
                                          type: linkTagType(tag.type),
                                          status: action,
                                      };
                                  })
                                  .filter(Boolean);
                          })()
                        : this.state.selectedTags;

                await transitUpdateTags(this.props.port.id, this.props.data.id, {
                    tags: tags,
                });

                // Handle comments if any
                const { id, text } = this.state.comment;
                if (id || text) {
                    if (id != null) {
                        // Update existing comment
                        await transitUpdateComment(this.props.port.id, id, this.state.comment);
                    } else {
                        // Create a new comment
                        await transitCreateComment(this.props.port.id, this.props.data.id, this.state.comment);
                    }
                }

                // Update transits and close
                this.props.mainControls.updateTransits([this.props.data.id], ['transit_tags', 'tag_slugs', 'comments']);
                this.props.actions?.onCancel();
            } catch (errors) {
                this.props.setErrorHandlerAction(errors);
            } finally {
                this.setState({ loading: false });
            }
        });
    };

    renderData = () => {
        this.setState({
            tabs: {
                tags: (
                    <TagsTab
                        key={0}
                        selectedTags={this.state.selectedTags.map((x) => {
                            return { id: x, usedForAll: true };
                        })}
                        errors={this.state.errors}
                        setTag={this.setTag}
                        actions={this.props.actions}
                    ></TagsTab>
                ),
                comments: (
                    <CommentsTab
                        key={1}
                        many={false}
                        comment={this.state.comment}
                        comments={this.state.comments}
                        errors={this.state.errors}
                        setComment={this.setComment}
                        editComment={this.editComment}
                        refreshComments={this.getComments}
                        actions={this.props.actions}
                    ></CommentsTab>
                ),
            },
        });
    };

    render() {
        return (
            <>
                <TabsLayout
                    activeTab={this.state.activeTab}
                    onTabChange={this.onTabChange}
                    tabs={this.state.tabs}
                    model="TransitTagsAndCommentsModel"
                    actions={{
                        onCancel: this.handleFormCancel,
                        onConfirm: this.handleFormSubmit,
                        onClear: this.handleFormClear,
                    }}
                />
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    openModelFunction: state.layout.openModelFunction,
    mainControls: state.layout.mainControls,
    port: state.port.port,
    tags: state.port.tags,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TransitTagsAndCommentsModel);
